import React from 'react';
import { Button } from 'anf-core-react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import trackAction from '../../../tools/analytics';

export default function ApplePayButton({
  classList,
  tmntData,
  isDisabled,
}) {
  const applePayBtnTMNTValue = tmntData?.applePayButtonTMNTValue?.value;
  return (
    <Button
      isFullWidth
      classList={clsx(classList, 'apple-pay')}
      onClick={() => {
        const newApplePayEvent = new CustomEvent('crs:applePay:openSheet', {
          detail: {
            isApplePayExpress: true,
          },
        });
        window.dispatchEvent(newApplePayEvent);
        trackAction('universal_click', {
          data_text: 'apple pay express',
          data_action: 'open',
          event_name: 'click',
        });
      }}
      isDisabled={isDisabled}
    >
      <span role="img" aria-label={applePayBtnTMNTValue} />
    </Button>
  );
}

ApplePayButton.defaultProps = {
  tmntData: {},
  classList: '',
  isDisabled: false,
};

ApplePayButton.propTypes = {
  tmntData: PropTypes.instanceOf(Object),
  classList: PropTypes.string,
  isDisabled: PropTypes.bool,
};
